export class ContratoModel {

    id:Number;
    tipoContratoId:number;
    nombre:String;
    fechaEntrada:Date;
    fechaExpiracion:Date;
    tarifaId:number;
    activo:boolean;
    createdBy:String;
    createdDate:Date;
    updatedBy:String;
    updatedDate:Date;

    public constructor(){
        this.id = null;
        this.tipoContratoId = null;
        this.nombre = null;
        this.fechaEntrada = null;
        this.fechaExpiracion = null;
        this.tarifaId = null;
        this.activo = null;
        this.createdBy = null;
        this.createdDate = null;
        this.updatedBy = null;
        this.updatedDate = null;    
    }
}